import { ViewProperties } from "../../../utils/ViewProperties";
/**
 * Properties for the feature cameras.
 */
export class GameFeatureCameraRigProperties extends ViewProperties {
}
//# sourceMappingURL=GameFeatureCameraRigProperties.js.map